import MetricsCardLink from "@home/components/MetricsCardLink";
import InGameAnalyticsFilter from "@home/pages/studio/inGameAnalytics/components/Filter";
import KpiCard from "@home/pages/studio/inGameAnalytics/components/KpiCard";
import OldInGameAnalytics from "@home/pages/studio/inGameAnalytics/components/OldInGameAnalytics";
import ProfitDistributionCard from "@home/pages/studio/inGameAnalytics/components/ProfitDistributionCard";
import ProfitDistributionService from "@home/pages/studio/inGameAnalytics/components/ProfitDistributionService";
import StudioMetricsCardTitle from "@home/pages/studio/inGameAnalytics/components/StudioMetricsCardTitle";

export default {
  InGameAnalyticsFilter,
  OldInGameAnalytics,
  ProfitDistributionCard,
  ProfitDistributionService,
  StudioMetricsCardTitle,
  KpiCard,
  MetricsCardLink,
};